import { Component, inject } from '@angular/core';
import { SVGIconComponent } from "@progress/kendo-angular-icons";
import { Icons } from "src/app/icons";
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { ROUTE_PATHS } from 'src/app/app.routes';
import { UrlService } from 'src/app/services/url.service';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    imports: [
        SVGIconComponent,
        ButtonComponent,
    ],
    styleUrl: './error.component.scss'
})
export class ErrorComponent {
  protected readonly icons = Icons;
  private urlService = inject(UrlService);

  redirectToForm() {
    window.location.href = this.urlService.getUrlForRoute(ROUTE_PATHS.FORM);
  }
}
